exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-form[data-v-8d091b32]{margin-bottom:20px}.filter-form .el-form-item[data-v-8d091b32]{margin-right:12px;margin-bottom:12px}", ""]);

// exports
